// extracted by mini-css-extract-plugin
module.exports = {"EditorCandidates":"_1FG2ha9i","titleBlock":"wKSq58Sp","title":"_2ii8sKu6","titleContainer":"_2UF7zBII","autoSaving":"_3pOM9UOC","autoSaved":"UhEbBIwl","saveContent":"_1hPXMnag","errorText":"nX6KHSPt","active":"_354i7DXo","inactive":"_1FM4Wn3w","category":"_3uD10FA6","backButtonContainer":"_9J322M1P","backButton":"_1JLvp9jF"};
    if(module.hot) {
      // 1754515035825
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  